import { DndContext, closestCenter, DragEndEvent } from '@dnd-kit/core'
import { SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable'
import { useMediaQueries } from 'builder/hooks/useMediaQueries'
import { Accomplishment } from 'builder/modules/sevenStories'
import { AccomplishmentsList, Container, Divider } from './style'
import { ToolTip } from './components/ToolTip'
import { AccomplishmentsLists } from './components/AccomplishmentsList'

type Props = {
  accomplishmentData: Accomplishment[]
  handleAccomplishmentSelect: (value: boolean, id: number) => void
  onSortEnd: (event: DragEndEvent) => void
  selectedAccomplishment: Accomplishment[]
  isMaxSelection: boolean
  handleCloseConfirmModal: () => void
  handleSubmitConfirmModal: () => void
  showConfirmModal: boolean
}

export const AccomplishmentsRank = ({
  accomplishmentData,
  handleAccomplishmentSelect,
  onSortEnd,
  isMaxSelection,
  selectedAccomplishment,
}: Props) => {
  const { isPhone } = useMediaQueries()
  // Required component only
  const isItemSelected = selectedAccomplishment.filter(item => item.isSelected).length > 0
  const newAccomplishmentData = accomplishmentData.filter(item => !item.isSelected)

  const SortableList = (items: Accomplishment[], isSelected: boolean) => {
    return (
      <DndContext
        onDragEnd={onSortEnd}
        collisionDetection={closestCenter}
        cancelDrop={cancelData =>
          (cancelData.activatorEvent.target as HTMLInputElement).id === 'select_check'
        }
      >
        <SortableContext items={items} strategy={verticalListSortingStrategy}>
          <AccomplishmentsList>
            {items
              ?.filter(item => !!item.description)
              .map((item, index) => (
                <AccomplishmentsLists
                  key={item.id}
                  {...{
                    index,
                    item,
                    isSelected,
                    isMaxSelection,
                    handleAccomplishmentSelect,
                    onSortEnd,
                  }}
                />
              ))}
          </AccomplishmentsList>
        </SortableContext>
      </DndContext>
    )
  }

  return (
    <>
      <Container>
        {!isPhone && <ToolTip />}
        {SortableList(selectedAccomplishment, true)}
        {isItemSelected && <Divider {...{ isItemSelected }} />}
        <AccomplishmentsList>{SortableList(newAccomplishmentData, false)}</AccomplishmentsList>
      </Container>
    </>
  )
}
